var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"docs-page"},[_c('Headers'),_c('div',{staticClass:"docs-container"},[_vm._v(" 待填充 ")]),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }